import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {IProduct, IProductGroup, IVariantDropDownValue} from "../product/product-models";
import * as _ from "lodash";
import {LoggerService} from "../common/logger.service";
import {UsanaObject} from "../usana-object";
import {FormUtil} from "../util/form-util";
import {CartUtil} from "../cart/cart-util";

@Component({
    selector: 'product-selection',
    templateUrl: './product-selection.component.html',
    styleUrls: ['./product-selection.component.scss'],
    standalone: false
})

export class ProductSelectionComponent extends UsanaObject implements OnInit, OnChanges {

    @Input() productGroup: IProductGroup;
    @Input() product: IProduct;
    @Input() btnClass: string;
    @Input() isCmsStyling: boolean = false;
    @Output() readonly updateProductEvent = new EventEmitter<IProduct>();

    selectOptions: FormGroup<Record<string, any>> | undefined;
    tempSelectedOptions: { [key: number]: IVariantDropDownValue } = {};

    constructor(
        loggerService: LoggerService,
        private fb: FormBuilder
    ) {
        super(loggerService);
    }

    ngOnInit() {
        this.init();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.product && this.productChanged(!changes.product.firstChange, changes.product.previousValue, changes.product.currentValue)) {
            this.init();
        }
    }

    get variants() {
        return this.selectOptions.get('variants') as FormArray;
    }

    init() {
        if (!!this.productGroup.variantDropDown && !!this.productGroup.variantDropDown[0]) {
            this.buildVariantSelectForm();
        }
    }

    isVariantSelected(optionId: number, i: number): boolean {
        return optionId === this.variants.controls[i].value.valueId;
    }

    productChanged(productUpdated: boolean, previousProduct: IProduct, currentProduct: IProduct) {
        return productUpdated && (currentProduct?.id !== previousProduct?.id || currentProduct?.usanaId !== previousProduct?.usanaId);
    }

    buildVariantSelectForm() {
        this.tempSelectedOptions = _.cloneDeep(CartUtil.selectedOptionsForProduct(this.product, this.productGroup));
        const sortedSelectedOptions = [];
        _.forEach(this.productGroup.variantDropDown, (dropdown) => {
            _.forEach(dropdown.values, (value) => {
                _.forEach(this.tempSelectedOptions, (option: any) => {
                    if (value.valueId === option.valueId) {
                        sortedSelectedOptions.push(option);
                    }
                });
            });
        });
        this.selectOptions = this.fb.group({
            variants: FormUtil.toFormArray(sortedSelectedOptions, this.fb)
        }) as unknown as FormGroup<Record<string, any>>;
    }

    updateVariantByDropdown(event: any, control: FormControl<any>, variant: any) {
        this.updateVariant(event.target.value, control, variant);
    }

    updateVariant(valueId: any, control: FormControl<any>, variant: any) {
        //find the productId with these selected options
        const selectedValue: IVariantDropDownValue = _.find(variant.values, (dropdown) => dropdown.valueId === parseInt(valueId));
        if (selectedValue) {
            control.setValue(selectedValue);
            this.tempSelectedOptions[variant.typeId] = selectedValue;

            const newProductId: number = CartUtil.productIdForSelectedOptions(this.productGroup, this.tempSelectedOptions);
            if (newProductId) {
                this.log.debug("updateVariant", "Select for variations changed, selected options and variantId", this.tempSelectedOptions, newProductId);
                this.product = _.find(this.productGroup.products, product => product.id === newProductId);
                this.updateProductEvent.emit(this.product);
            }
        } else {
            this.product = {productDescription: {name: 'Invalid'}};
            this.log.error("updateVariant", "This combo doesn't exist, or stuff broke", this.tempSelectedOptions);
        }
    }
}
